import * as React from 'react'
import { StringItemSelector } from './ItemSelector'

interface ITimeSelectorProps {
  hours: number
  minutes: number
  onTimeChanged?: (hours: number, minutes: number) => void
}

const TimeSelector = (props: ITimeSelectorProps) => {
  const handleHourSelected = (index: number, hour: string) => {
    if (props.onTimeChanged) {
      props.onTimeChanged(index, props.minutes)
    }
  }

  const handleMinuteSelected = (index: number, minute: string) => {
    if (props.onTimeChanged) {
      props.onTimeChanged(props.hours, index)
    }
  }

  const getHourItems = (): string[] => {
    const hours = []
    for (let i = 0; i < 24; i++) {
      const hour = i < 10 ? `0${i}` : `${i}`
      hours.push(hour)
    }
    return hours
  }

  const getMinuteItems = (): string[] => {
    const minutes = []
    for (let i = 0; i < 60; i++) {
      const minute = i < 10 ? `0${i}` : `${i}`
      minutes.push(minute)
    }
    return minutes
  }

  return (
    <div className='my3 flex flex-wrap relative col-12'>
      <StringItemSelector items={getHourItems()} selectedIndex={props.hours} onItemSelected={handleHourSelected} />
      <div className='ml2'>
        <StringItemSelector
          items={getMinuteItems()}
          selectedIndex={props.minutes}
          onItemSelected={handleMinuteSelected}
        />
      </div>
    </div>
  )
}

export default TimeSelector



// WEBPACK FOOTER //
// ./src/components/ui/TimeSelector.tsx